'use strict';

/**
 *
 * @name: ddComments
 *
 */

import DirectiveTemplate from './nn-dropdown-comments.directive.html';

function NnDropdownCommentsDirective(apiCommentsService, $rootScope, $timeout, playersAnalytics) {

  'ngInject';

  return {
    replace: true,
    template: DirectiveTemplate,
    scope: {
      post: '=',
      showComments: '=',
      toggleDd: '='
    },
    link: function(scope, element) {

      scope.playersAnalytics = playersAnalytics;

      var commentsGoCompile = $rootScope.$on('goCompile', function() {

        $timeout(function() {

          runComments();
        });
      });

      var watchShowComments = scope.$watch('showComments', function(newVal) {

        if (newVal === true) {
          $(element).slideDown(250);
        } else {
          $(element).slideUp(250);
        }
      });

      function runComments() {

        scope.showLoadMoreButton = false;

        // show comments
        scope.comments = [];

        apiCommentsService
          .getComments(scope.post.id)
          .then(function(res) {

            res.data.items.forEach(function(item) {

              item.displayDate = moment(item.createdAt).fromNow();
            });

            scope.comments = scope.comments.concat(res.data.items);

            if (scope.comments.length > 10) {

              scope.showLoadMoreButton = true;
            }
          });

        // load more comments
        var commentPager = 2;

        scope.loadMoreComments = function() {
          scope.loadingComments = true;
          scope.showLoadMoreButton = false;

          apiCommentsService
            .getComments(scope.post.id, commentPager)
            .then(function(res) {

              if (res.data.items.length > 0) {

                commentPager++;

                res.data.items.forEach(function(item) {

                  item.displayDate = moment(item.createdAt).fromNow();
                });

                scope.comments = scope.comments.concat(res.data.items);

                if (res.data.items.length > 10) {

                  scope.showLoadMoreButton = true;
                }

                scope.loadingComments = false;
              } else {

                scope.loadingComments = false;
              }
            }, function() {

              scope.loadingComments = false;
            });

        };

        // post comment
        scope.newComment = {
          text: '',
          UserId: $rootScope.profile.id,
          PostId: scope.post.id,
          language: $rootScope.lang
        };

        scope.keyUp = function(e) {

          if (e.keyCode === 13) {

            scope.postComment();
          }
        };

        scope.postComment = function() {

          scope.addingComment = true;
          scope.playersAnalytics.videoAction('Submit a comment');

          apiCommentsService
            .postComment(scope.newComment)
            .then(function(res) {

              res.data.justAdded = true;
              scope.post['commentsCount_' + $rootScope.lang2]++;
              res.data.displayDate = moment(res.data.createdAt).fromNow();
              res.data.user = {
                displayName: $rootScope.profile.displayName,
                slug: $rootScope.profile.slug,
                id: $rootScope.profile.id,
                photoUrl: $rootScope.profile.photoUrl,
                isPublic: $rootScope.profile.isPublic
              };
              scope.comments.unshift(res.data);
              scope.addingComment = false;
              scope.newComment.text = '';
            }, function() {

              scope.addingComment = false;
            });
        };

        scope.deleteComment = function(comment) {

          apiCommentsService
            .deleteComment(comment.id)
            .then(function() {

              comment.text = null;
            });
        };

        scope.downvote = function(comment) {

          if (comment.userVote === -1) {
            return;
          }

          var oldUserVote = comment.userVote;
          comment.downVotes++;

          if (oldUserVote === 1) {

            comment.upVotes--;
          }

          comment.userVote = -1;

          apiCommentsService
            .downvote(comment.id)
            .then(function() {}, function() {

              comment.downVotes--;
              comment.userVote = oldUserVote;
              if (oldUserVote === 1) {
                comment.upVotes++;
              }
            });
        };

        scope.upvote = function(comment) {

          if (comment.userVote === 1) {

            return;
          }

          var oldUserVote = comment.userVote;
          comment.upVotes++;

          if (oldUserVote === -1) {

            comment.downVotes--;
          }

          comment.userVote = 1;

          apiCommentsService
            .upvote(comment.id)
            .then(function() {}, function() {

              comment.upVotes--;
              comment.userVote = oldUserVote;

              if (oldUserVote === -1) {

                comment.downVotes++;
              }
            });
        };

      }

      runComments();

      scope.$on('$destroy', function() {

        commentsGoCompile();
        watchShowComments();
        element.find('*').remove();
      });
    }
  };
}

export default NnDropdownCommentsDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-dropdown-comments/nn-dropdown-comments.directive.js